<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> Svn相关
                </el-breadcrumb-item>
                <el-breadcrumb-item>SVN服务状态</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class="plugins-tips">
                <el-row>
                    <el-col :span="13">
                        <div class="grid-content bg-purple-dark" style="margin-bottom: 6px">
                            <!-- Server 服务状态 -->
                            <el-alert
                                v-show="showStatusSuccess"
                                style="background: #F5F7FA; padding: 0;"
                                :title="'获取Server状态 ' + lastTime"
                                type="success"
                                :closable=false
                                show-icon>
                            </el-alert>
                            <el-alert
                                v-show="showStatusWarning"
                                style="background: #F5F7FA; padding: 0;"
                                :title="'获取Server状态 ' + lastTime"
                                type="warning"
                                :closable=false
                                show-icon>
                            </el-alert>
                        </div>
                        <div class="grid-content bg-purple-dark" style="margin-bottom: 6px">
                            <span class="serverStatusContent">SvnEdge 服务 &nbsp;</span>
                            <el-tooltip :content="'SvnEdge: ' + edgeStatus" placement="top">
                                <el-switch
                                    :disabled="perm == false"
                                    v-model="edgeStatus"
                                    @change="changeSvnEdge($event)"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    active-value="运行中"
                                    inactive-value="停机中">
                                </el-switch>
                            </el-tooltip>
                            <span 
                                class = "serverStatusLoding"
                                v-loading = showEdgeStatusLoading
                                element-loading-spinner="el-icon-loading">
                            </span>
                            <span v-show="showEdgeError" style="font-size: 9px; margin-left: 35px; color: red">SVN服务状态异常，请联系管理员重启服务（重启后请稍等1-2分钟等待重启完毕）</span>
                        </div>
                        <div class="grid-content bg-purple-dark">
                            <span class="serverStatusContent">SvnServer 服务</span>
                            <el-tooltip :content="'SvnServer: ' + serviceStatus" placement="top">
                                <el-switch
                                    :disabled="svnRole != ''"
                                    v-model="serviceStatus"
                                    @change="changeSvnService($event)"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    active-value="运行中"
                                    inactive-value="停机中">
                                </el-switch>
                            </el-tooltip>
                            <span 
                                class = "serverStatusLoding"
                                v-loading = showStatusLoading
                                element-loading-spinner="el-icon-loading">
                            </span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple-dark" v-show="perm">
                            <el-button :type="this.hostType" style="float:right" size="small" round @click="restartHost()" 
                                       :loading="showHostLoading">重启主机 ( {{this.hostStatus}} )
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="plugins-tips" v-show="svnRole == ''">
                <el-row>
                    <el-col :span="24" style="margin-bottom: 15px">
                        <span class="serverStatusContent">远程服务地址 </span>
                        <el-switch
                            v-model="remoteService"
                            @change="changeRemoteService($event)"
                            active-color="#13ce66">
                        </el-switch>
                        <span class="serverStatusContent serviceUrl" :class="remoteService ? 'selectedUrl' : ''">{{remoteServiceUrl}} </span>
                    </el-col>
                    <el-col :span="24">
                        <span class="serverStatusContent">本地服务地址 </span>
                        <el-switch
                            v-model="localService"
                            @change="changeLocalService($event)"
                            active-color="#13ce66">
                        </el-switch>
                        <span class="serverStatusContent serviceUrl" :class="localService ? 'selectedUrl' : ''">{{localServiceUrl}} </span>
                    </el-col>
                    
                </el-row>
            </div>

            <div class="plugins-tips">
                <el-row>
                    <el-col :span="24" style="margin-bottom: 15px">
                        <span class="serverStatusContent">远程根目录</span>
                        <span class="serverStatusContent" style="margin-left: 13px; cursor: pointer">
                            
                            <a style="cursor: pointer" href="https://server.cottongame.com/svn/" target="_blank"> https://server.cottongame.com/svn/</a>
                        </span>
                    </el-col>
                    <el-col :span="24">
                        <span class="serverStatusContent">局域网根目录 </span>
                        <span class="serverStatusContent" >
                            <a style="cursor: pointer" href="https://192.168.0.122:18080/svn/" target="_blank"> https://192.168.0.122:18080/svn/</a>
                        </span>
                    </el-col>
                    
                </el-row>
            </div>
        </div>
    </div>
    
</template>

<script>
import moment from 'moment' 
import { localServiceUrl, remoteServiceUrl, getHostStatus, restartHost, getEdgeStatus, operationEdge, startEdgeLog, 
         stopEdgeLog, getServiceStatus } from '../../api/svnAPI.js'
import bus from '../../common/bus.js';
export default {
    name: 'svnStatus',
    data() {
        return {
            hostStatus: '未知',   // 主机
            hostType: '',
            serviceStatus: '',// SVN 服务
            edgeStatus: '',   // SVN 控制台
            showHostLoading: false,       // 主机 loading
            showStatusLoading: false,     // 服务 loading
            showEdgeStatusLoading: false, // 控制台 loading

            hostName: '',    // 主机名
            fatherFile: '',  // 版本库父文件
            repository: '',  // 浏览库版本

            serviceUrl: remoteServiceUrl,    // SVN 服务地址
            
            showEdgeError: false,
            showStatusSuccess: false,
            showStatusWarning: true,

            lastTime: '', // 最后更新时间

            localServiceUrl: localServiceUrl,
            localService: false,   // 本地服务地址
            remoteServiceUrl: remoteServiceUrl,
            remoteService: false,  // 远程服务地址
 
            // 身份令牌
            sessId: localStorage.getItem(localStorage.getItem('ms_username') + 'sessId'),
            // svn权限角色  svnRole   1.超级管理    2.普通用户   3.系统管理   4.版本库管理   5.Repository管理    6.用户管理
            svnRole : localStorage.getItem('svnRole'),
            // 页面权限
            perm: true 
        };
    },
    mounted() {
        this.serviceUrl = localStorage.getItem(localStorage.getItem("ms_username") + 'ServiceUrl', this.remoteServiceUrl)
        this.sessId = localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')

        //页面权限
        let role = JSON.stringify(localStorage.getItem('role1'))
        this.perm = role.indexOf('all') != -1

        this.initHost()
        
        setTimeout(() => {
            // 初始化数据
            this.initEdge()
            this.initData()
        }, 400);

        setInterval(this.initData, 1000 * 40)
    },
    activated() {
        this.serviceUrl = localStorage.getItem(localStorage.getItem("ms_username") + 'ServiceUrl', this.remoteServiceUrl)
        this.svnRole = localStorage.getItem('svnRole')
        this.sessId = localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
        
        this.initHost()
        
        setTimeout(() => {
            // 初始化数据
            this.initEdge()
            this.initData()
        }, 400);
    },
    methods: {
        // 获取 Host状态
        initHost() {
            getHostStatus(null).then(res => {
                if (res.data.indexOf('200') != -1) {
                    if (res.data.indexOf('运行中') != -1) {
                        this.hostStatus = '运行中'
                        this.hostType = 'success'
                    }
                } else {
                    this.hostStatus = '停机中'
                    this.hostType = 'info'
                }
            }).catch(err => {
                this.hostStatus = '停机中'
                this.hostType = 'info'
            })
        },

        // 获取 Edge状态
        initEdge() {
            // 获取 SVN控制台运行状态
            getEdgeStatus(null).then(res => {
                if (res.data.indexOf('200') != -1) {
                    if (res.data.indexOf('运行中') != -1) this.edgeStatus = '运行中'
                    if (res.data.indexOf('停机中') != -1) {
                        this.edgeStatus = '停机中' 
                        this.showEdgeError = true
                    } 
                } else {
                    this.showEdgeError = true
                }
            }).catch(err => {
                this.showEdgeError = true
            })
        },

        // 获取 数据
        initData() {
            // 获取 SVN服务运行状态
            let params = {'url': this.serviceUrl}
            getServiceStatus(params).then(res => {
                if (res.data.code == 200) {
                    this.serviceStatus = res.data.data.statusMsg

                    this.hostName = res.data.data.hostName
                    this.fatherFile = res.data.data.fatherFile
                    this.repository = res.data.data.repository

                    this.showStatusSuccess = true
                    this.showStatusWarning = false

                    if (res.data.data.statusMsg == undefined || res.data.data.statusMsg == '') {
                        this.showStatusSuccess = false
                        this.showStatusWarning = true
                    }
                } else if (res.data.code == 777) {
                    this.$message.warning(res.data.message)
                    this.loginDialogVisible = true
                } else if (res.data.code == 778) {
                    this.$notify({
                        title: '警告',
                        message: 'Svn服务未响应',
                        type: 'warning'
                    });
                }
                this.lastTime = moment(new Date()).format('MM/DD HH:mm:ss')
            }).catch(error => {
                this.showStatusSuccess = false
                this.showStatusWarning = true
                this.serviceStatus = '停机中'
                this.lastTime = moment(new Date()).format('MM/DD HH:mm:ss')
            })
            //判断 SVN服务地址
            this.serviceUrl.indexOf('127.0.0.1') != -1 ? this.localService = true : this.remoteService = true
        },
        
        //SVN服务按钮
        changeSvnService(event) {
            //验证 获取状态是否成功 , 否则不可点击
            if (this.showStatusSuccess != true) this.$message.warning('状态获取异常')

            //点击后, 等发送请求成功后, 再改变样式
            if (event == '停机中') {
                this.serviceStatus = '运行中'

                this.$confirm('确定要关闭服务吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.showStatusLoading = true
                    this.postSvnService('停止' ,event)
                })
            }

            //点击后, 等发送请求成功后, 再改变样式
            if (event == '运行中') {
                this.showStatusLoading = true
                this.serviceStatus = '停机中'
                this.postSvnService('启动' ,event)
            }
        },

        //执行 Svn服务
        postSvnService(startOrStop, event) {
            let params = {'startOrStop': startOrStop, 'url': this.serviceUrl, 'sessId': this.sessId}
            if (startOrStop == '启动') {
                startService(params).then(res => {
                    if (res.data.code == 200) {
                        setTimeout(() => {
                            this.serviceStatus = event
                            this.$message.success(res.data.message)
                            this.showStatusLoading = false
                        }, 3000);

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }

            if (startOrStop == '停止') {
                stopService(params).then(res => {
                    if (res.data.code == 200) {
                        setTimeout(() => {
                            this.serviceStatus = event
                            this.$message.success(res.data.message)
                            this.showStatusLoading = false
                        }, 3000);
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }
        },

        //SVNEdge 按钮
        changeSvnEdge (event) {
            //点击后, 等发送请求成功后, 再改变样式
            if (event == '停机中') {
                this.edgeStatus = '运行中'

                this.$confirm('确定要关闭服务吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.showEdgeStatusLoading = true
                    this.postSvnEdge('停止' ,event)
                    this.showEdgeError = true
                })
            }

            //点击后, 等发送请求成功后, 再改变样式
            if (event == '运行中') {
                this.showEdgeStatusLoading = true
                this.edgeStatus = '停机中'
                this.postSvnEdge('启动' ,event)
                this.showEdgeError = false
            }
        },

        //执行SvnEdge
        postSvnEdge(startOrStop, event) {
            //
            let params = {'startOrStop': startOrStop, 'url': 'C:/Users/yehang/nircmd-x64/nircmd.exe'}
            operationEdge(params).then(res => {
                if (res.data.indexOf('200')) {
                    setTimeout(() => {
                        this.edgeStatus = event
                        this.$message.success('请求成功')
                        this.showEdgeStatusLoading = false

                        //存储日志
                        if (startOrStop == '启动') startEdgeLog(null).then()
                        if (startOrStop == '停止') stopEdgeLog(null).then()
                    }, 3000);
                    
                } else {
                    this.$message.error('请求失败')
                    this.showEdgeError = true
                }
                //调用Sidebar.vue 更新Svn左侧栏
                bus.$emit('refSvnLeftMenu')
            })
        },

        // 重启 主机
        restartHost() {
            if (this.hostStatus == '停机中') {
                return
            }
            this.$confirm('确定要重启主机吗？', '提示', {
                    type: 'warning'
            }).then(() => {
                //点击后, 等发送请求成功后, 再改变样式
                this.showHostLoading = true
                this.hostStatus = '运行中'
                restartHost(null).then(res => {
                    if (res.data.indexOf('200')) {
                        setTimeout(() => {
                            this.hostStatus = '停机中'
                            this.hostType = 'info'
                            this.$message.success('请求成功')
                            this.showHostLoading = false
                        }, 3000);
                    }
                }).catch(err => {
                    this.$message.success('请求失败')
                    this.showHostLoading = false
                })
            }).catch(err => {})
        },

        //本地地址开关
        changeLocalService(event) {
            if (event == false) {
                if (this.remoteService == event) this.localService = !event
            }

            if (event == true) {
                localStorage.setItem(localStorage.getItem("ms_username") + 'ServiceUrl', this.localServiceUrl)
                this.remoteService = !event
            }
        },
        //远程地址开关
        changeRemoteService(event) {
            if (event == false) {
                if (this.localService == event) this.remoteService = !event
            }

            if (event == true) {
                localStorage.setItem(localStorage.getItem("ms_username") + 'ServiceUrl', this.remoteServiceUrl)
                this.localService = !event
            } 
        },
    }
};
</script>
<style scoped lang="scss">
* {
    cursor: default;
}
.container {
    .plugins-tips {
        color: #333333;
        .bg-purple-dark {
            padding-top: 8px;
        }
        .serverStatusContent {
            font-size: 14px;
            font-weight: 600;
            margin-right: 20px;
        }
        //状态 主机名
        .el-row {
            margin-top: 20px;
            &:nth-child(1) {
                margin-top: 0;
            }
        }

        .serviceUrl {
            margin-left: 100px;
            color: #909399;
        }
        //被选择的 服务地址
        .selectedUrl {
            color: #333333;
        }
    }
}
</style>